import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { upperCase } from 'lodash';
import { Row, Col, Checkbox } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';
import CommonButton from '../../common/Button';
import { GroupBlock, NotificationRow, CustomDivider, CenteredCol } from './styled';

@injectIntl
class NotificationsSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.updateBreadcrumbs(
      {
        name: this.props.intl.formatMessage({ id: 'settingsModal.notifications' }),
      },
      true
    );
  }

  onChange = e => {
    this.props.setNotificationChange(e.target.value, e.target.checked);
  };

  renderNotifications = (groupName, groupId, notifications) =>
    notifications.map(notification => (
      <div
        className={`setting-group-notification-${groupName}`}
        key={`setting-group-notification-${groupName}_${notification.name}`}
      >
        <NotificationRow>
          <Col span={6}>{notification.name}</Col>
          <CenteredCol span={6}>
            <Checkbox
              value={`${groupId}.${notification.id}.topBar`}
              checked={notification.topBar}
              onChange={this.onChange}
            />
          </CenteredCol>
          <CenteredCol span={6}>
            <Checkbox
              value={`${groupId}.${notification.id}.email`}
              checked={notification.email}
              onChange={this.onChange}
            />
          </CenteredCol>
          <CenteredCol span={6}>
            <Checkbox
              value={`${groupId}.${notification.id}.phone`}
              checked={notification.phone}
              onChange={this.onChange}
            />
          </CenteredCol>
        </NotificationRow>
      </div>
    ));

  renderGroupsAndRows = notificationsData =>
    notificationsData.map(group => (
      <GroupBlock className={`setting-group-${group.name}`} key={`setting-group-${group.name}`}>
        <Row>
          <Col span={6}>
            <span style={{ fontWeight: '500' }}>{group.name}</span>
          </Col>
        </Row>
        {this.renderNotifications(group.name, group.groupId, group.notifications)}
      </GroupBlock>
    ));

  render() {
    const { notificationsData } = this.props;
    return (
      <div>
        <Row>
          <Col span={6}>
            <FormattedMessage id="notifications.notification" defaultMessage="Notification">
              {txt => <span style={{ fontWeight: '500' }}>{upperCase(txt)}</span>}
            </FormattedMessage>
          </Col>
          <CenteredCol span={6}>
            <FormattedMessage id="notifications.topBar" defaultMessage="Top Bar">
              {txt => <span style={{ fontWeight: '500' }}>{upperCase(txt)}</span>}
            </FormattedMessage>
          </CenteredCol>
          <CenteredCol span={6}>
            <FormattedMessage id="common.email" defaultMessage="Email">
              {txt => <span style={{ fontWeight: '500' }}>{upperCase(txt)}</span>}
            </FormattedMessage>
          </CenteredCol>
          <CenteredCol span={6}>
            <FormattedMessage id="notifications.phone" defaultMessage="Phone">
              {txt => <span style={{ fontWeight: '500' }}>{upperCase(txt)}</span>}
            </FormattedMessage>
          </CenteredCol>
        </Row>
        <CustomDivider />
        <div>
          {this.renderGroupsAndRows(notificationsData)}
        </div>
        <div style={{ marginTop: '3em' }}>
          <CommonButton type="normal" clickHandler={this.props.restoreDefaults}>
            <FormattedMessage
              id="notifications.restoreDefaults"
              defaultMessage="Restore Defaults"
            />
          </CommonButton>
        </div>
      </div>
    );
  }
}

NotificationsSettings.propTypes = {
  intl: PropTypes.object,
  notificationsData: PropTypes.array,
  setNotificationChange: PropTypes.func,
  restoreDefaults: PropTypes.func,
  updateBreadcrumbs: PropTypes.func,
};

export default NotificationsSettings;
